module.exports = __webpack_public_path__ + "img/loading.12283468.png";